// React
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

// Components
import LegalAddr from "./LegalAddr"
import MailingAddr from "./MailingAddr"

// Services
import {
  fetchDistricts,
  fetchSubDistricts,
  fetchProvinces,
} from "./fetchGeoData"

interface ErrorType {
  prefixOther?: { message?: string }
  firstName?: { message?: string }
  lastName?: { message?: string }
  gender?: { message?: string }
  weight?: { message?: string }
  height?: { message?: string }
  dateOfBirth?: { message?: string }
  idCardNumber?: { message?: string }
  phoneNumber?: { message?: string }
}

type AddressInfoProps = {
  data: any
  legalErrors: ErrorType
  mailingErros: ErrorType
  same_address?: any
}

interface IDistrict {
  id: number
  name_th: string
  name_en: string
  province_id: number
  created_at: string
  updated_at: string
  deleted_at: null
}

interface ISubDistrict {
  id: number
  zip_code: number
  name_th: string
  name_en: string
  amphure_id: number
}

const AddressInfo: React.FC<AddressInfoProps> = ({
  data,
  legalErrors,
  mailingErros,
}) => {
  const navigate = useNavigate()
  // const sameAddress = data.mailingAddressInfo.same_as_legal_address
  const [districts, setDistricts] = useState<IDistrict[]>([])
  // const [sameAddress, setSameAddress] = useState<boolean>(true)
  const [subDistricts, setSubDistricts] = useState<ISubDistrict[]>([])
  const [provinceJSON, setProvinceJSON] = useState<any[]>([])

  const legal_address = data?.AppFormAddress.find(
    (address: any) => address.address_type === "LEGAL"
  )
  const mailing_address = data?.AppFormAddress.find(
    (address: any) => address.address_type === "MAILING"
  )
  useEffect(() => {
    const fetchDistrictsData = async () => {
      try {
        const districtsData = await fetchDistricts()
        setDistricts(districtsData)
      } catch (error) {
        navigate("/servererror", { replace: true })
      }
    }

    const fetchSubDistrictsData = async () => {
      try {
        const subDistrictsData = await fetchSubDistricts()
        setSubDistricts(subDistrictsData)
      } catch (error) {
        navigate("/servererror", { replace: true })
      }
    }

    const fetchProvincesData = async () => {
      try {
        const provincesData = await fetchProvinces()
        setProvinceJSON(provincesData)
      } catch (error) {
        navigate("/servererror", { replace: true })
      }
    }

    fetchProvincesData()

    fetchDistrictsData()
    fetchSubDistrictsData()
  }, [])

  return (
    <div>
      <LegalAddr
        data={legal_address}
        errors={legalErrors}
        provinces={provinceJSON}
        districts={districts}
        subDistricts={subDistricts}
      />
      <MailingAddr
        data={mailing_address}
        same_as_legal_address={data?.same_address}
        errors={mailingErros}
        provinces={provinceJSON}
        districts={districts}
        subDistricts={subDistricts}
      />
    </div>
  )
}

export default AddressInfo
